import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';

export const FeatureGuard = ({ feature, children, fallbackPath = '/dashboard' }) => {
  const { hasFeature, user } = useAuth();
  const [showUpgradeModal, setShowUpgradeModal] = useState(true);

  // Admin bypass - admins can access everything
  if (user?.is_admin) {
    return <>{children}</>;
  }

  // Check if user has the required feature
  if (hasFeature(feature)) {
    return <>{children}</>;
  }

  // Feature not available - show upgrade modal
  if (showUpgradeModal) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0B0F14' }}>
        <div className="max-w-md w-full mx-4">
          <div 
            className="p-8 rounded-2xl border-2 text-center"
            style={{ 
              backgroundColor: '#0F141A',
              borderColor: '#1EA0E6',
              boxShadow: '0 0 40px rgba(30, 160, 230, 0.3)'
            }}
          >
            <div 
              className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{ backgroundColor: '#1EA0E620' }}
            >
              <Lock className="w-10 h-10" style={{ color: '#1EA0E6' }} />
            </div>

            <h2 className="text-2xl font-bold mb-3" style={{ color: '#E6EDF3' }}>
              Feature nicht verfügbar
            </h2>

            <p className="text-base mb-6" style={{ color: '#94A3B8' }}>
              Dieses Feature ist in Ihrem aktuellen Plan nicht enthalten. 
              Upgraden Sie jetzt, um Zugriff zu erhalten!
            </p>

            <div 
              className="p-4 rounded-lg mb-6"
              style={{ backgroundColor: '#1EA0E610', border: '1px solid #1EA0E6' }}
            >
              <div className="flex items-center justify-center gap-2 mb-2">
                <Sparkles className="w-5 h-5" style={{ color: '#1EA0E6' }} />
                <span className="font-semibold" style={{ color: '#1EA0E6' }}>
                  Verfügbar in höheren Plänen
                </span>
              </div>
              <p className="text-sm" style={{ color: '#94A3B8' }}>
                Schalten Sie Premium-Features frei und holen Sie mehr aus CarCortex heraus
              </p>
            </div>

            <div className="flex gap-3">
              <Button
                onClick={() => setShowUpgradeModal(false)}
                variant="outline"
                className="flex-1"
              >
                Zurück
              </Button>
              <Button
                onClick={() => window.location.href = '/settings?tab=subscription'}
                className="flex-1"
                style={{ backgroundColor: '#1EA0E6', color: '#fff' }}
              >
                Plan upgraden
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If modal closed, redirect to fallback
  return <Navigate to={fallbackPath} replace />;
};

export default FeatureGuard;
